const DesktopAdProfiles = {
  allTop: /* 新聞內頁最上方廣告(第一屏 banner) */ {
    name: 'cnyes_news_inside_all_top',
    path: '/1018855/cnyes_news_inside_all_top',
    size: [[970, 250]]
  },
  asideBannerTop: /* 側邊欄摩天輪 */ {
    name: 'aside-banner-top',
    path: '/1018855/cnyes_news_insideright_300*250',
    size: [[300, 600]]
  },
  allBottom: /* 新聞內頁最上方廣告(第一屏 banner) */ {
    name: 'cnyes_news_inside_all_bottom',
    path: '/1018855/cnyes_twstock_inside_970*250_bottom',
    size: [[970, 250]]
  },
  newsDetailInterested1: {
    // 相關新聞第一則
    name: 'cnyes_newsarticle_list_native_1',
    path: '/1018855/cnyes_newsarticle_list_native_1',
    size: [[800, 105]]
  }
};

export default DesktopAdProfiles;
